import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { useDispatch } from 'react-redux';
import CardFace from '../Card/CardFace';
import { viewCard } from '../Card/actions';
import { PlainButton } from '../Controls';
import Energies from '../Pokemon/Energies';
import { CardLayout, Details, Stat } from './styled';

/**
 * The card a menu is about, big enough to read, with its remaining HP, attached energy and any protection from
 * attacks when it is in play.
 * Tapping the card shows it full screen.
 */
const CardDetail = ({
  card, damage, energyAttachments, protection, hindrance, hinderedBy, trainers, conversions, children,
}) => {
  const dispatch = useDispatch();
  const hp = card && card.get('hp');

  return (
    <CardLayout>
      <PlainButton onClick={() => card && dispatch(viewCard(card))} aria-label="Show card full screen">
        <CardFace
          card={card}
          damage={damage}
          energyAttachments={energyAttachments}
          protection={protection}
          hindrance={hindrance}
          hinderedBy={hinderedBy}
          trainers={trainers}
          conversions={conversions}
        />
      </PlainButton>
      <Details>
        {hp > 0 && damage !== undefined && <Stat>HP <b>{Math.max(hp - (damage || 0), 0)}</b> of {hp}</Stat>}
        {energyAttachments && <Energies energyAttachments={energyAttachments} />}
        {protection && <Stat>{protection} this turn</Stat>}
        {hinderedBy && <Stat>{hinderedBy}: {hindrance} this turn</Stat>}
        {trainers && trainers.size > 0 && <Stat>Attached: {trainers.join(', ')}</Stat>}
        {conversions && conversions.map(text => <Stat key={text}>{text} (Conversion)</Stat>)}
        {children}
      </Details>
    </CardLayout>
  );
};

CardDetail.propTypes = {
  card: PropTypes.instanceOf(Map),
  trainers: PropTypes.instanceOf(List),
  conversions: PropTypes.instanceOf(List),
  damage: PropTypes.number,
  energyAttachments: PropTypes.instanceOf(List),
  /** Like "Protected from damage", from the server. */
  protection: PropTypes.string,
  /** From an opponent's attack, like Amnesia: what it stops ("Can't use Ember") and the attack's name. */
  hindrance: PropTypes.string,
  hinderedBy: PropTypes.string,
  children: PropTypes.node,
};

export default CardDetail;
